var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3047 10.3371C10.7189 10.4696 11 10.8547 11 11.2895V18.3098C11 18.9873 10.3405 19.4687 9.69527 19.2622L3.69527 17.3425C3.28107 17.21 3 16.825 3 16.3901V9.36986C3 8.69239 3.65947 8.21098 4.30473 8.41742L10.3047 10.3371ZM21 16.3901C21 16.825 20.7189 17.21 20.3047 17.3425L14.3047 19.2622C13.6595 19.4687 13 18.9873 13 18.3098V11.2895C13 10.8547 13.2811 10.4696 13.6953 10.3371L19.6953 8.41742C20.3405 8.21098 21 8.69239 21 9.36986V16.3901Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15706 6.82141C3.85609 6.7378 3.86735 6.30726 4.17228 6.23949L11.1323 4.69283C11.7038 4.56582 12.2962 4.56582 12.8677 4.69283L19.8277 6.23949C20.1327 6.30726 20.1439 6.7378 19.8429 6.82141L13.0706 8.70262C12.3701 8.89719 11.6299 8.89719 10.9294 8.70262L4.15706 6.82141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.8ebc841dbb178b93253b02d1e9bcaa6b.svg";
export { ForwardRef as ReactComponent };